import React, { useEffect } from 'react';
import { Formik } from 'formik';
import { connect } from 'react-redux';
// [redux -- users]

import {
  currentUserSelector,
  usersAsValueAndLabelSelectors,
  usersIsLoadingSelector
} from '../../../modules/users/Selectors';

import { getUserAction, getUsersAction } from '../../../modules/users/Actions';

import {
  InputField,
  FormGroup,
  CheckBox,
  FormSectionTitle,
  Separator,
  SearchableSelect,
  Select
} from '../../../components/form';

import {
  createCustomerAction,
  updateCustomerAction,
  getCustomerAction,
  updateCustomerLimitAction
} from '../../../modules/customers/Actions';

import {
  customersIsLoadingSelector,
  customerByIdSelector
} from '../../../modules/customers/Selectors';

import Schema from '../customers/customersSchema';
import setWizardPage from '../../../helpers/setWizardPage';
import { globalFail } from '../../../modules/globalFail/Selector';
import { setRedirectFalse } from '../../../modules/globalFail/Action';
import Customeri18n from '../../../components/form/i18nForm/FormBIOi18n';
import { authCurrentDefaultTypeSelecetor } from '../../../modules/auth/Selectors';
import { updateAuthCustomerAction } from '../../../modules/auth/Actions';
import getLangData from '../../../utils/getLangData';

const options = [
  { value: ['0'], label: 'Individual' },
  { value: ['1'], label: 'Company' }
];

const companySizeOptions = [
  {
    label: '1-10',
    value: '1-10'
  },
  {
    label: '10-100',
    value: '10-100'
  },
  {
    label: '100-1000',
    value: '100-1000'
  },
  {
    label: 'More Than 1000',
    value: '1000+'
  }
];

const CustomersForm = props => {
  const { getUsers, mappedUsers, usersIsLoading, customerData, edit } = props;

  const {
    getCustomer,
    updateCustomer,
    createCustomer,
    customerId,
    customer,
    customersIsLoading,
    page,
    setPage,
    currentUser,
    fail,
    redirectFalse,
    getSingleUser,
    reload,
    defaultUserType,
    updateLimits,
    updateAuthCustomer,
    staging,
    authId
  } = props;

  useEffect(() => {
    // getUsers();
    if (customerId) {
      getCustomer(customerId);
    }
  }, [getCustomer, customerId]);

  useEffect(() => {
    if (!edit) {
      fail && setWizardPage(page, '4', setPage);
      redirectFalse();
      // reload && window.location.reload();
      if (reload) {
        fail && window.location.reload();
      }
    }
  }, [fail]);

  return (
    <Formik
      enableReinitialize
      validationSchema={Schema(!customer ? true : false)}
      initialValues={customerData ? { ...customerData } : Schema().cast()}
      onSubmit={values => {
        // console.log(values)
        const userID = values.userID._id;
        const geolocation = [-2.777434, 53.7222317];

        const { _id } = currentUser;
        if (edit) {
          if (defaultUserType === '0' || defaultUserType === '1') {
            updateCustomer(values._id, { ...values, userID: values._id });
          } else {
            values.geolocation = geolocation;
            updateAuthCustomer({ customerID: customerData._id, ...values });
          }
        } else {
          if (staging) {
            createCustomer({ ...values, userID: authId, geolocation });
          } else {
            createCustomer({ ...values, userID: _id, geolocation }, true);
          }
          // !fail && setWizardPage(page, '4', setPage);
          // getSingleUser(_id);
          // reload && window.location.reload();
        }
      }}
    >
      {({ handleSubmit, values, errors }) => (
        <FormGroup
          heading={edit ? getLangData().fields.update_customer : getLangData().fields.create_customer}
          handleSubmit={handleSubmit}
          isLoading={customersIsLoading}
          errors={errors}
        >
          {console.log('cust', errors)}
          <FormSectionTitle>{getLangData().tables.basic_info}</FormSectionTitle>
          {/* <SearchableSelect
            isLoading={usersIsLoading}
            options={mappedUsers}
            getItems={getUsers}
            name='userID'
            label='User'
            optionLabel={(option) => `${option.firstName} ${option.lastName}`}
          /> */}
          <InputField
            label={getLangData().fields.busience_name}
            name='businessName'
          />
          <Customeri18n
            name='businessNamei18n'
            description={getLangData().fields.busience_name}
          />
          <Select
            options={getLangData().customer_register_page.fields.customerType}
            name='customerType'
            label={
              getLangData().customer_register_page.fields.customerType[0].label
            }
            inArray={true}
          />
          <Separator />
          <FormSectionTitle>
            {getLangData().customer_register_page.fields.company}
          </FormSectionTitle>
          <InputField
            name='yearEstablished'
            label={getLangData().fields.year_established}
          />
          <CheckBox
            name='regCompany'
            label={getLangData().fields.registered_company}
            subLabel='I have Registered Company.'
          />{' '}
          <InputField
            label={getLangData().fields.company_size}
            name='companySize'
          />
          {/*           <Select
            options={companySizeOptions}
            name='companySize'
            label='Company Size'
          /> */}
          <Separator />
          {defaultUserType === '0' && customerData && (
            <>
              <FormSectionTitle>Customer Status :</FormSectionTitle>
              <CheckBox name='verified' label='Verified' />
              <CheckBox name='trusted' label='Trusted' />
              <FormSectionTitle>Customer Limit</FormSectionTitle>
              <InputField name='subscriptionModel.artisanPublicInquiriesLimit' />
              <InputField name='subscriptionModel.artisanPrivateInquiriesLimit' />
              <InputField name='subscriptionModel.supplierPrivateInquiriesLimit' />
              <InputField name='subscriptionModel.supplierPublicInquiriesLimit' />
              <InputField name='subscriptionModel.directionInquiriesLimit' />
              <div
                className='btn btn-primary'
                onClick={() => {
                  if (defaultUserType === '0') {
                    const data = {
                      customerID: values._id,
                      artisanPublicInquiriesLimit:
                        values.subscriptionModel.artisanPublicInquiriesLimit,
                      artisanPrivateInquiriesLimit:
                        values.subscriptionModel.artisanPrivateInquiriesLimit,
                      supplierPrivateInquiriesLimit:
                        values.subscriptionModel.supplierPrivateInquiriesLimit,
                      supplierPublicInquiriesLimit:
                        values.subscriptionModel.supplierPublicInquiriesLimit,
                      directionInquiriesLimit:
                        values.subscriptionModel.directionInquiriesLimit
                    };
                    updateLimits(data);
                  }
                }}
              >
                Update Limits
              </div>
            </>
          )}
          {/* <FormSectionTitle>Customer Status</FormSectionTitle>
          <CheckBox name="verified" label="Verified" />
          <CheckBox name="trusted" label="Trusted" /> */}
          {/* <CheckBox name='moderated' label='Moderated' /> */}
        </FormGroup>
      )}
    </Formik>
  );
};

const mapStateToProps = (state, props) => {
  const customerId = props.match?.params.id;

  return {
    // users
    mappedUsers: usersAsValueAndLabelSelectors(state),
    usersIsLoading: usersIsLoadingSelector(state),
    currentUser: currentUserSelector(state),
    fail: globalFail(state),
    // customers
    customerId,
    customer: customerByIdSelector(state, customerId),
    customersIsLoading: customersIsLoadingSelector(state),
    defaultUserType: authCurrentDefaultTypeSelecetor(state)
  };
};

const mapDispatchToProps = {
  // users
  getUsers: getUsersAction,
  redirectFalse: setRedirectFalse,
  // customers
  createCustomer: createCustomerAction,
  updateCustomer: updateCustomerAction,
  getCustomer: getCustomerAction,
  getSingleUser: getUserAction,
  updateLimits: updateCustomerLimitAction,
  updateAuthCustomer: updateAuthCustomerAction
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomersForm);
